
import React      from 'react';
import CSSModules from 'react-css-modules';

import classNames   from 'classnames/bind';
import stylingUtils from '../../services/stylingUtilities';

import FontIcon from '../FontIcon';

import style from './style.scss';

class GlobalMessage extends React.Component {

    _getMessageClassName() {

        var cx = classNames.bind(style);

        var baseStyle = {
            'message': true,
            'message--success': this.props.type === 'success',
            'message--error': this.props.type === 'error'
        };

        return cx(stylingUtils.mergeClassNames(baseStyle, this.props.className));
    }

    _getMessageIcon() {

        if (this.props.type === 'error') {

            return (
                <FontIcon className={ style['message__icon'] }
                          iconName="exclamation-triangle" />
            );

        } else if (this.props.type === 'success') {

            return (
                <FontIcon className={ style['message__icon'] }
                          iconName="check" />
            );

        } else {

            return (
                <FontIcon className={ style['message__icon'] }
                          iconName="info-circle" />
            );
        }
    }

    render() {

        if (this.props.show) {

            return (
                <div className={ this._getMessageClassName() }>

                    { this._getMessageIcon() }

                    <span styleName="message__contents">
                        { this.props.children }
                    </span>
                </div>
            );
        }
    }
}

export default CSSModules(GlobalMessage, style);


// WEBPACK FOOTER //
// ./components/GlobalMessage/index.js